// Constants.js
const getEnv = () => {
  // If REACT_APP_ENV is explicitly set, use it
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV.toLowerCase()
  }
  
  //  if URL includes localhost, use development
  if (typeof window !== 'undefined' && window.location.hostname.includes('localhost')) {
    return 'development'
  }
  
  // Default to production
  return 'production'
}

const ENV = getEnv()

// Development
const DEV_CONNECT_URL = 'https://test.swifteq.com'
const DEV_PUBLIC_URL = `http://localhost:${process.env.REACT_APP_PORT || 3000}`
const DEV_API_URL = `http://localhost:${process.env.REACT_APP_API_PORT || 3005}/api`
const DEV_HC_EVENTS_DOMAIN = `http://localhost:${process.env.REACT_APP_API_PORT || 3005}`
const DEV_HC_SCRIPT_URL = `${DEV_HC_EVENTS_DOMAIN}/scripts/hc_events.js`
const DEV_AGENT_HELPER_URL = 'http://localhost:3000'
const DEV_AUTH = {
  domain: 'auth-dev.swifteq.com',
  clientId: 'ApKuNY9ffZLxhGC5L29nbtl3NLFXWLAE',
  audience: 'https://agenthelp.swifteq.com/api',
}

// Staging
const STAGING_CONNECT_URL = 'https://hcmanager-staging.swifteq.com'
const STAGING_PUBLIC_URL = 'https://hcmanager-staging.swifteq.com'
const STAGING_API_URL = 'https://hcmanager-staging.swifteq.com/api'
const STAGING_HC_EVENTS_DOMAIN = 'https://hcmanager-staging.swifteq.com'
const STAGING_HC_SCRIPT_URL = 'https://scripts.swifteq.com/hc_events.js'
const STAGING_AGENT_HELPER_URL = 'https://agenthelper.swifteq.com'
const STAGING_AUTH = {
  domain: 'auth-dev.swifteq.com',
  clientId: 'ApKuNY9ffZLxhGC5L29nbtl3NLFXWLAE',
  audience: 'https://agenthelp.swifteq.com/api',
}

// Production
const PROD_PUBLIC_URL = 'https://hcmanager.swifteq.com'
const PROD_API_URL = 'https://hcmanager.swifteq.com/api'
const PROD_HC_EVENTS_DOMAIN = 'https://hcmanager.swifteq.com'
const PROD_HC_SCRIPT_URL = 'https://scripts.swifteq.com/hc_events.js'
const PROD_AGENT_HELPER_URL = 'https://agenthelper.swifteq.com'
const PROD_AUTH = {
  domain: 'auth.swifteq.com',
  clientId: 'AJnfgTH2wZNEQYUYEeOKfOOKXoBDtCzY',
  audience: 'https://agenthelp.swifteq.com/api',
}

const selectConfig = (dev, staging, prod) => {
  switch (ENV) {
    case 'development':
    case 'dev':
      return dev
    case 'staging':
    case 'stage':
      return staging
    case 'production':
    case 'prod':
      return prod
    default:
      console.warn(`Unknown environment: ${ENV}, falling back to development`)
      return dev
  }
}

export const CONNECT_URL = selectConfig(DEV_CONNECT_URL, STAGING_CONNECT_URL, PROD_PUBLIC_URL)
export const PUBLIC_URL = selectConfig(DEV_PUBLIC_URL, STAGING_PUBLIC_URL, PROD_PUBLIC_URL)
export const API_URL = selectConfig(DEV_API_URL, STAGING_API_URL, PROD_API_URL)
export const HC_EVENTS_DOMAIN = selectConfig(DEV_HC_EVENTS_DOMAIN, STAGING_HC_EVENTS_DOMAIN, PROD_HC_EVENTS_DOMAIN)
export const HC_SCRIPT_URL = selectConfig(DEV_HC_SCRIPT_URL, STAGING_HC_SCRIPT_URL, PROD_HC_SCRIPT_URL)
export const AGENT_HELPER_URL = selectConfig(DEV_AGENT_HELPER_URL, STAGING_AGENT_HELPER_URL, PROD_AGENT_HELPER_URL)

export const AUTH_CONFIG = selectConfig(DEV_AUTH, STAGING_AUTH, PROD_AUTH)

export const LOCAL_APPS = ['hcmanager', 'hctranslate', 'hcanalytics']
